import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Contacts from "Admissions/routes/admissionUnit/routes/contacts";
import Segments from "Admissions/routes/admissionUnit/routes/segments";
import Deduplication from "Admissions/routes/admissionUnit/routes/deduplication";
import Campaigns from "Admissions/routes/admissionUnit/routes/campaigns";
import Events from "Admissions/routes/admissionUnit/routes/events";
import Appointments from "Admissions/routes/admissionUnit/routes/appointments";
import Enrollment from "Admissions/routes/admissionUnit/routes/enrollment";
import Waitlist from "Admissions/routes/admissionUnit/routes/waitlist";
import ReEnrolment from "Admissions/routes/admissionUnit/routes/reEnrolment";
import Workflows from "Admissions/routes/admissionUnit/routes/workflows";
import AdminPortal from "Admissions/routes/admissionUnit/routes/adminPortal";

// Owns the `:unitId` URL segment. Every admissions surface lives under a
// unit, so this route holds:
//   - AdmissionsShell as the wrapping component (global header + sidebar +
//     pre-warmed unit/academic-year caches)
//   - indexRoute that redirects bare `/admissions/:unitId` to enrollment
//   - the full child route list (CRM, marketing, admin portal, etc.)
//
// Future unit-scoped concerns (invalid-unit guard, unit-loaded context, etc.)
// land here.
export default store => ({
  path: ":unitId",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-shell" */ "Admissions/features/Admissions/components/AdmissionsShell"
    ).then(m => m.default)
  ),
  indexRoute: {
    // Default landing inside a unit is the CRM contacts page.
    onEnter: (nextState, replace) =>
      replace(`/admissions/${nextState.params.unitId}/contacts`),
  },
  childRoutes: [
    Contacts(store),
    Segments(store),
    Deduplication(store),
    Campaigns(store),
    Events(store),
    Appointments(store),
    Enrollment(store),
    Waitlist(store),
    ReEnrolment(store),
    Workflows(store),
    AdminPortal(store),
  ],
});
